// Política v1: años calendario en Argentina, NO un número fijo de 790 días.
export const ARCHIVE_POLICY = 'calins-2y-60d-v1';
export const ARCHIVE_MAX_FILES = 50;
export const ARCHIVE_MAX_BYTES = 128 * 1024 * 1024;

export function retentionDeadline(issuedAt, years = 2, days = 60) {
  if (!issuedAt) return null;
  const instant = new Date(issuedAt);
  if (!Number.isFinite(instant.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Argentina/Buenos_Aires', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  }).formatToParts(instant);
  const p = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  const year = Number(p.year) + years;
  const month = Number(p.month);
  const day = Math.min(Number(p.day), new Date(Date.UTC(year, month, 0)).getUTCDate());
  // Las fechas nuevas de esta política usan ART (UTC-03). La autoridad para
  // fechas históricas y limpieza es PostgreSQL con la zona IANA completa.
  return new Date(Date.UTC(year, month - 1, day + days, Number(p.hour) + 3,
    Number(p.minute), Number(p.second), instant.getUTCMilliseconds())).toISOString();
}

export async function sha256(data) {
  const bytes = data instanceof Blob ? await data.arrayBuffer() : data;
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function certificateObjectPath(clientId, instrumentId, versionId, external = false) {
  const segment = (value) => encodeURIComponent(String(value || 'sin-dato'));
  return `${segment(clientId || 'sin-cliente')}/${segment(instrumentId)}/${external ? 'ext-' : ''}${segment(versionId)}.pdf`;
}

export function archiveLabel(row, now = new Date()) {
  if (row.storage_deleted_at) return 'Archivado; fuera de Supabase';
  if (row.hold_reason || !row.purge_after) return 'Protegido: requiere revisión';
  if (new Date(row.purge_after) <= now) {
    if (!row.archive_confirmed_at) return 'Plazo cumplido: falta copia en Drive';
    return row.simulation_candidate === true ? 'Elegible en simulación' : 'Copia confirmada: revisar elegibilidad';
  }
  if (row.archive_confirmed_at) return 'Copia en Drive confirmada';
  if (new Date(row.purge_after).getTime() - now.getTime() <= 7 * 86400000) return 'Aviso urgente: quedan 7 días o menos para el límite; falta copia en Drive';
  const warning = retentionDeadline(row.retention_started_at, 2, 0);
  return warning && new Date(warning) <= now ? 'Aviso: archivar durante el margen de 60 días' : 'Pendiente de archivo en Drive';
}

export function driveArchiveUrl(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.hostname !== 'drive.google.com' || url.username || url.password || url.port) return null;
    if (!/^\/(?:drive\/(?:u\/\d+\/)?folders\/|file\/d\/)[A-Za-z0-9_-]+(?:\/.*)?$/.test(url.pathname)) return null;
    return url.href;
  } catch { return null; }
}

export function csvCell(value) {
  // Evita ejecutar fórmulas al abrir el índice en Excel.
  const text = String(value ?? '');
  return `"${(/^[\s]*[=+@-]/.test(text) ? "'" : '') + text.replaceAll('"', '""')}"`;
}
